/*
 * TSS custom — Preorder label sync (not part of the Sleek theme; re-add after theme updates)
 *
 * Any product tagged  "preorder: <message>"  (e.g. "preorder: Ships early December")
 * gets a visible  PREORDER: <MESSAGE>  line item property in the cart, no matter HOW it was
 * added: product page, MW Bundle Builder pop-up, Sleek add-ons, cart recommendations, etc.
 * Because it's a real line item property, it carries through to checkout and the order.
 *
 * Only some variants on preorder? Put the variant name between "preorder" and the colon:
 *   "preorder 2027: Ships early December"  -> only variants whose name contains "2027"
 *   "preorder: Ships early December"       -> every variant of the product
 *
 * Change the message  -> edit the product's tag in Shopify admin.
 * Stop the preorder   -> remove the tag.
 */
(function () {
  if (window.__tssPreorderSync) return;
  window.__tssPreorderSync = true;

  var TAG_WORD = 'preorder';
  var PROPERTY_NAME = 'PREORDER';
  var EXISTING_LABEL_RE = /pre-?order/i; // skip lines that already carry a visible preorder property (e.g. set by a preorder app)
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var nativeFetch = window.fetch.bind(window);
  var productCache = {};
  var running = false;
  var queued = false;
  var timer = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Returns the preorder message for this variant, or null.
  // A variant-specific tag ("preorder 2027: ...") wins over a product-wide one ("preorder: ...").
  function messageFromTags(tags, variantTitle) {
    var variant = String(variantTitle || '').toLowerCase();
    var productWide = null;
    for (var i = 0; i < (tags || []).length; i++) {
      var tag = String(tags[i]).trim();
      var colon = tag.indexOf(':');
      if (colon < 0) continue;
      var head = tag.slice(0, colon).trim().toLowerCase();
      var message = tag.slice(colon + 1).trim();
      if (!message || head.indexOf(TAG_WORD) !== 0) continue;
      var filter = head.slice(TAG_WORD.length).trim();
      if (!filter) {
        if (!productWide) productWide = message;
      } else if (variant.indexOf(filter) !== -1) {
        return message;
      }
    }
    return productWide;
  }

  function hasPreorderLabel(properties) {
    if (!properties) return false;
    return Object.keys(properties).some(function (key) {
      var value = properties[key];
      return key.charAt(0) !== '_' && EXISTING_LABEL_RE.test(key) && value != null && String(value).trim() !== '';
    });
  }

  function getProductTags(handle) {
    if (!productCache[handle]) {
      productCache[handle] = nativeFetch(root() + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? p.tags || [] : []; })
        .catch(function () { return []; });
    }
    return productCache[handle];
  }

  function refreshCartUI() {
    // Cart page: simplest reliable refresh.
    if (document.querySelector('main-cart')) {
      window.location.reload();
      return;
    }
    // Cart drawer: Sleek re-renders the drawer on this event.
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
  }

  async function sync() {
    if (running) { queued = true; return; }
    running = true;
    var changed = false;
    try {
      var cart = await nativeFetch(root() + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      }).then(function (r) { return r.json(); });

      for (var i = 0; i < (cart.items || []).length; i++) {
        var item = cart.items[i];
        if (hasPreorderLabel(item.properties)) continue;
        var message = messageFromTags(await getProductTags(item.handle), item.variant_title);
        if (!message) continue;

        var properties = Object.assign({}, item.properties || {});
        properties[PROPERTY_NAME] = message.toUpperCase(); // caps so checkout + order match the cart

        var res = await nativeFetch(root() + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties }),
        });
        if (res.ok) changed = true;
      }
    } catch (e) {
      console.warn('[preorder-sync]', e);
    }
    running = false;
    if (changed) refreshCartUI();
    if (queued) { queued = false; schedule(); }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  function isCartMutation(url) {
    return CART_MUTATION_RE.test(String(url || '').split('#')[0]);
  }

  // Watch fetch() cart calls made by the theme and apps.
  window.fetch = function (input, init) {
    var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
    var promise = nativeFetch(input, init);
    if (isCartMutation(url)) promise.then(schedule, function () {});
    return promise;
  };

  // Watch XMLHttpRequest cart calls (some apps still use it).
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__tssCartMutation = isCartMutation(url);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__tssCartMutation) this.addEventListener('loadend', schedule);
    return origSend.apply(this, arguments);
  };

  // Backstop for apps that cached fetch before this script ran: MW Bundle Builder fires this after adding.
  document.addEventListener('product-ajax:added', schedule);
  document.body
    ? document.body.addEventListener('cart:refresh', function (e) { if (e.target !== document) schedule(); })
    : document.addEventListener('DOMContentLoaded', function () {
        document.body.addEventListener('cart:refresh', function (e) { if (e.target !== document) schedule(); });
      });

  // On page load (covers normal form posts to /cart/add and items added before this fix).
  function initialCheck() {
    if (document.documentElement.classList.contains('cart-has-items')) schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialCheck);
  else initialCheck();

  window.__tssPreorderSyncNow = sync; // handy for testing in the browser console
})();
